module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.back($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tScreen monitoring\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.back
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)]), _vm._v(" "), _c('form', {
    staticClass: "modal__section",
    class: {
      'has-error': _vm.errors.any()
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateScreenMonitoring($event)
      }
    }
  }, [_c('div', {
    staticClass: "screen-monitoring-modal__option"
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": _vm.isSaving,
      "hide-details": "",
      "label": "Auto refresh screenshots"
    },
    model: {
      value: (_vm.credential.isEnabled),
      callback: function($$v) {
        _vm.$set(_vm.credential, "isEnabled", $$v)
      },
      expression: "credential.isEnabled"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "screen-monitoring-modal__description"
  }, [_vm._v("\n                            Periodically it takes preview screens in the background on your online Android devices\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "screen-monitoring-modal__option"
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": _vm.isSaving,
      "hide-details": "",
      "label": "Enable screen permission requesting"
    },
    model: {
      value: (_vm.credential.reqPermission),
      callback: function($$v) {
        _vm.$set(_vm.credential, "reqPermission", $$v)
      },
      expression: "credential.reqPermission"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "screen-monitoring-modal__description"
  }, [_vm._v("\n\t\t\t\t\t\t\tIf the screen permission has not been enabled with this setting enable or disable the auto permission request window\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "type": "submit",
      "loading": _vm.isSaving,
      "disabled": _vm.isSaving,
      "color": "primary"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSave settings\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('apierror')),
      expression: "errors.has('apierror')"
    }],
    staticClass: "input-field__error"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('apierror')) + " ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f85dfdb","hasScoped":false}!./app/components/screen-monitoring-modal/template.html
// module id = 383
// module chunks = 0